<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NrQ21H/tc-custom/9781504070041.jpg?1737330570414" alt="This image is the cover for the book Destiny Series Books One to Three, The Destiny Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Destiny Series Books One to Three, The Destiny Series
      </h1>
      <p class="bookDescription body article font2">
        <b>The first three novels in the acclaimed series full of romance, betrayal, and family drama on the French countryside.</b><br/><br/><b>Rosie and Ruby</b><br/><br/>Ruby lives with her feckless mother in a rundown Manchester estate. Her cousin Rosie lives in charming, quiet Cheshire with her own domineering mother. Then there is Olivia, a member of Cheshire’s elite whose son Marcus lives in the fast lane. When Ruby meets Marcus, the secrets of her past come to light. In her hour of need, will her cousin come to her rescue?<br/><br/><b>Anna</b><br/><br/>Anna was content to be the stable, overlooked rock of her family. But when she discovers her husband’s affair, her life turns upside down. With one son far away, another about to enter a war zone, and her daughter off to university, Anna must face the pain alone. But when someone from her past appears, can Anna find peace and learn to love again?<br/><br/><b>Tilly</b><br/><br/>Matilda Parker is in France for what should be her dream wedding. But her mother Freda has spent a year planning the event, and nothing is going to get in her way. On the other side of the village, Anna has problems of her own. She vows that nothing will ruin her family’s summer holiday. But when a visitor from hell arrives and Tilly meets someone new, Anna and Freda’s plans start going up in smoke.<br/><br/><i>Rosie and Ruby</i> was previously published under the title <i>Three Mothers.</i><br/><br/><i>Anna </i>was previously published as <i>A Bientôt.</i><br/><br/><i>Tilly </i>was previously published under the title <i>A Perfect Summer Wedding</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Dixon
      </h2>
      
      <p class="authorDescription body article">Patricia Dixon was born in Manchester where she still lives with her husband. They have two grown up children and one grandson, plus the company of a lazy bulldog.   Ignoring her high school reports and possibly sound advice from teachers, Patricia shunned the world of academia and instead, stubbornly pursued a career in fashion. Once the sparkle of London life wore off she returned north and embarked on a new adventure, that of motherhood.   Now, almost thirty years later she has acquiesced to the wise words of her elders and turned her hand to writing. Patricia has written five novels set in the Loire and then, in complete contrast, a much darker story of psychological suspense.  She is currently writing her next book, a murderous tale set in the sixties and if she’s not at her desk Patricia loves to read historical fiction or attempts recipes that look great on television but not necessarily her plate. And when the penny jar is full she cashes in her coins and heads to France, the lure of red wine and escapism equalled only by the pursuance of her dream job, writing for a living.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bombshell Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54680091